import React, { useState } from "react";
import { handleCreateTemplate } from "../../modules/templateModules.ts";
import {toast, ToastContainer} from 'react-toastify';import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/common/BreadCrumb.tsx";
import { CardBody, Col, Input, Row, Table } from "reactstrap";
import { LabelText } from "../../components/common/Labeltext.tsx";
import SelectField from "../../components/common/SelectField.tsx";
import { Link } from "react-router-dom";

const DatasetHeaderManager = () => {
  //const toast = useToast();
  const navigate = useNavigate();
  const [templateName, setTemplateName] = useState("");
  const [headers, setHeaders] = useState([
    { id: 1, name: "", type: "", defaultValue: "" },
  ]);

  // const dataTypeOptions = ["String", "Integer", "Float", "Boolean", "Datetime"];
  const dataTypeOptions = [
    { "label": "String", "value": "String" },
    { "label": "Integer", "value": "Integer" },
    { "label": "Float", "value": "Float" },
    { "label": "Boolean", "value": "Boolean" },
    { "label": "Datetime", "value": "Datetime" },
  ]
  const booleanOptions = [
    { "label": "True", "value": "True" },
    { "label": "False", "value": "False" },
  ]
  // const booleanOptions = ["True", "False"];

  // Check if first row is completely filled
  const isFirstRowComplete = () => {
    const firstRow = headers[0];
    return firstRow.name.trim() !== "" && firstRow.type.trim() !== "" && firstRow.defaultValue.trim() !== "";
  };

  const addColumn = () => {
    const newId =
      headers.length > 0 ? Math.max(...headers.map((h) => h.id)) + 1 : 1;
    setHeaders([
      ...headers,
      { id: newId, name: "", type: "", defaultValue: "" },
    ]);
  };

  const deleteColumn = (id) => {
    setHeaders(headers.filter((header) => header.id !== id));
  };

  const clearFirstRow = () => {
    setHeaders(
      headers.map((header) =>
        header.id === 1 ? { ...header, name: "", type: "", defaultValue: "" } : header
      )
    );
  };

  const handleNameChange = (id, value) => {
    setHeaders(
      headers.map((header) =>
        header.id === id ? { ...header, name: value } : header
      )
    );
  };

  const handleTypeChange = (id, value) => {
    setHeaders(
      headers.map((header) =>
        header.id === id ? { ...header, type: value, defaultValue: "" } : header
      )
    );
  };

  const handleDefaultValueChange = (id, value, type) => {
    let validatedValue = value;

    if (type === "Integer") {
      validatedValue = value.replace(/(?!^)-|[^\d-]/g, "");
    } else if (type === "Float") {
      validatedValue = value.replace(/[^\d.]/g, "");
      const parts = validatedValue.split(".");
      if (parts.length > 2) {
        validatedValue = parts[0] + "." + parts.slice(1).join("");
      }
    }

    setHeaders(
      headers.map((header) =>
        header.id === id ? { ...header, defaultValue: validatedValue } : header
      )
    );
  };


  const renderDefaultValueInput = (header) => {
    switch (header.type) {
      case "Boolean":
        return (
          <SelectField
            className={""}
            value={booleanOptions.find(opt => opt.value === header.defaultValue)}
            placeholder={" "}
            handleChange={(selectedOption) => {
              handleDefaultValueChange(header.id, selectedOption.value || "", header.type)
            }}
            options={booleanOptions}
            isRVStyle={true}
          />
        );

      case "Integer":
        return (
          <Input
            type="text"
            value={header.defaultValue}
            onChange={(e) => handleDefaultValueChange(header.id, e.target.value.replace(/(?!^)-|[^\d-]/g, ""), header.type)}
            placeholder="Enter an integer"
          />
        );

      case "Float":
        return (
          <Input
            type="text"
            value={header.defaultValue}
            onChange={(e) => handleDefaultValueChange(header.id, e.target.value.replace(/[^\d.]/g, ""), header.type)}
            placeholder="Enter a decimal number"
          />
        );

      case "Datetime":
        return (
          <Input
            type="datetime-local"
            value={header.defaultValue}
            onChange={(e) => handleDefaultValueChange(header.id, e.target.value, header.type)}
          />
        );

      case "String":
      default:
        return (
          <Input
            type="text"
            value={header.defaultValue}
            onChange={(e) => handleDefaultValueChange(header.id, e.target.value, header.type)}
            placeholder="Enter a value"
          />
        );
    }
  };

  const handleSubmit = async () => {
    if (!templateName.trim()) {
      toast.error("Template name is required.");
      return;
    }

    if (headers.some((header) => !header.name.trim() || !header.type.trim())) {
      toast.error("All headers must have a name and a data type.");
      return;
    }

    const payload = {
      template_name: templateName,
      template_schema: headers.map(({ name, type, defaultValue }) => ({
        column_name: name,
        data_type: type.toLowerCase(),
        default_value: defaultValue,
      })),
    };

    try {
      const response = await handleCreateTemplate(payload);
      if (response?.status === 201 && response?.message) {
        toast.success(response.message);
        navigate("/");
      } else {
        toast.success("Template created successfully!");
        navigate("/");
      }
    } catch (error: any) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Failed to create template.");
      }
    }
  };

  return (
    <>
      <BreadCrumb moduleName={"Template"} pageName={"Create Template"} />
      <ToastContainer position="top-center" />
      <div className="listingjs-table " id="customerList">
        <div className="live-preview">
          <div className="align-items-center d-flex mb-3 ">
            <h4 className="card-title mb-0 flex-grow-1">Create Template</h4>
          </div>
          <div className="border table-border p-3">
            <div className=''>
              <CardBody>
                <Row className="gy-2 pt-1 pb-2 ">
                  <Col lg={12}>
                    <LabelText
                      htmlFor={"TemplateName"}
                      className={"text-danger"}
                      displayText={"Template Name"}
                      important={"*"}
                    />
                    <LabelText
                      htmlFor={"TemplatePlaceholder"}
                      classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                      displayText={"Enter your template name"}
                    />
                    <Input
                      type="text"
                      value={templateName}
                      onChange={(e) => setTemplateName(e.target.value)}
                    />
                  </Col>
                </Row>
              </CardBody>
            </div>
          </div>
          <div className="border table-border p-3 mt-3">
            <CardBody>
              <div className="scrollable-view">
                <LabelText
                  htmlFor={"TemplateName"}
                  className={"text-danger"}
                  displayText={"Manage Dataset Headers"}
                  important={"*"}
                />
                <LabelText
                  htmlFor={"TemplatePlaceholder"}
                  classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                  displayText={"Manage dataset headers by adding or removing columns as needed."}
                />
                <Table className="table-borderless align-middle table-nowrap ms-2 mb-0 overflow-auto">
                  <thead>
                    <tr>
                      <th className="px-0 mx-0" scope="col">Headers</th>
                      <th scope="px-0 mx-0">Data Type</th>
                      <th scope="px-0 mx-0">Default Value</th>
                      <th scope="px-0 mx-0"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {headers && (
                      headers.map((header, index) => (
                        (
                          <tr key={index} className="ms-3">
                            <td className="w-xl px-0 mx-0">
                              <Input
                                type="text"
                                value={header.name}
                                onChange={(e) => handleNameChange(header.id, e.target.value)}
                                placeholder="Enter a header name"
                              />
                            </td>
                            <td className="w-xl">
                              <SelectField
                                className={""}
                                value={dataTypeOptions.find(opt => opt.value === header.type)}
                                placeholder={" "}
                                handleChange={(selectedOption) => {
                                  handleTypeChange(header.id, selectedOption.value || "")
                                }}
                                options={dataTypeOptions}
                                isRVStyle={true}
                              />
                            </td>
                            <td className="w-xl">
                              {renderDefaultValueInput(header)}
                            </td>
                            <td className="w-xl">
                              {index === 0 ? (
                                // First row: Show + and X icons only when row is complete
                                <div className="d-flex gap-2">
                                  <button
                                    onClick={addColumn}
                                    disabled={!isFirstRowComplete()}
                                  >
                                    <i className={`${!isFirstRowComplete() ? "opacity-75" : ""} ri-add-circle-line fs-5 text-primary mt-1 me-1`}></i>
                                  </button>

                                  <button
                                    onClick={clearFirstRow}
                                    disabled={!isFirstRowComplete()}
                                  >
                                    <i className={`${!isFirstRowComplete() ? "opacity-75" : ""} ri-close-line fw-bold align-middle fs-4 cross-icon-color`}></i>
                                  </button>
                                </div>
                              ) : (
                                // Subsequent rows: Show delete icon
                                <Link
                                  to="#"
                                  className="link-danger fs-5"
                                  onClick={() => deleteColumn(header.id)}
                                >
                                  <i
                                    data-testid="delete"
                                    className="ri-delete-bin-5-line"
                                  ></i>
                                </Link>
                              )}
                            </td>
                          </tr>
                        )
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </div>
          <Row lg={6} className=" justify-content-end  mt-4">
            <div className="live-preview">
              <div className="d-flex justify-content-end gap-2 mb-5">
                <button
                  type="button"
                  className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap btn btn-secondary"
                  onClick={() => {
                    navigate('/')
                  }}
                >
                  <i className="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                  <span className="px-2 ms-2 me-1 fw-bold">
                    Cancel
                  </span>
                </button>
                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap btn btn-secondary"
                >
                  <i className="ri-save-line label-icon align-middle fs-16 me-1"></i>
                  <span className="px-2 ps-3 ms-2 me-1 fw-bold">
                    Save
                  </span>
                </button>
              </div>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};

export default DatasetHeaderManager;